import{s as r}from"../classes/semver.js";const s=r;var t=(r,t,e=!1)=>{if(r instanceof s)return r;try{return new s(r,t)}catch(r){if(!e)return null;throw r}};export{t as p};
